export const logGooglePageView = (path: string) => {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('Google Analytics Page View:', path)
    }
    // gtag('event', 'page_view', {
    //   page_path: path,
    // })
  } catch (err) {
    console.error(err)
  }
}

export const logGoogleEvent = (name: string, params?: any) => {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('Google Analytics Event:', { name, params })
    }
    // gtag('event', name, params)
  } catch (err) {
    console.error(err)
  }
}

type LogGoogleSetUserDataOptions = {
  email: string
  phone_number?: string
}

export const googleSetUserData = ({ email, phone_number }: LogGoogleSetUserDataOptions) => {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('Google Analytics Set User Data:', { email, phone_number })
    }
    // gtag('set', 'user_data', {
    //   email,
    //   phone_number,
    // })
  } catch (err) {
    console.error(err)
  }
}
